angular.module("Main").controller("RegisterDialogController", ["$rootScope", "$scope", "$localStorage", "$location", "$state", "$cookies", "$uibModal", "$uibModalInstance", "AuthenticationService", "BookingService", "data",
    function ($rootScope, $scope, $localStorage, $location, $state, $cookies, $uibModal, $uibModalInstance, AuthenticationService, BookingService, data) {
        var vm = this;

        vm.dataForm = {};
        vm.registerFinish = false;
        vm.booking = {};
        vm.isLoggedIn = false;
        vm.isMember = false;
        vm.openFormForgotPassword = false;
        vm.isDuplicate = false;
        vm.isDeIban = false;
        vm.nichtKostenlos = data.Preis > 0 ;
        vm.passwordSecretNew = 'password';
        vm.isVersionRegistration = false;

        loadConfigs();
        getRegistrationConfig();
        loadVersion()

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.privacytermsText = data.PrivacyPolicy;
            });
        }

        function getRegistrationConfig() {
            BookingService.getRegistrationConfig().then(function (regConfig) {
                vm.registrationRequiredFields = regConfig;
            })
        }

        function loadVersion() {
            return BookingService.getVersions().then(function (versionData) {
                vm.centerComVersion = versionData.centercomVersion;
                if(vm.centerComVersion >= "6.74.0.0") {
                    vm.isVersionRegistration = true;
                }
            });
        }

        $('#register-dialog-focus').focus();

        vm.passwordFieldToogle = function () {
            if (vm.passwordSecretNew === 'password') {
                vm.passwordSecretNew = 'text'
            } else {
                vm.passwordSecretNew = 'password';
            }
        };


        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.openForgotPassword = function (email) {
            vm.openFormForgotPassword = true;
            vm.openFormChangePassword = false;
            if (email !== null)
                vm.emailForgot = true;

            $uibModalInstance.dismiss();
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/forgotPassword.html",
                controller: "ForgotPasswordController",
                controllerAs: "vm",
                backdrop: "static",
                windowClass: 'position-class'
            });
        };
        let checkDataRunning = false;
        vm.registerAndBook = function (registration) {
            vm.dataForm.salutation.$setTouched();
            vm.dataForm.firstname.$setTouched();
            vm.dataForm.lastname.$setTouched();
            vm.dataForm.email.$setTouched();
            if(vm.centerComVersion >= "6.74.0.0") {
                if( vm.dataForm.birthday) {
                    vm.dataForm.birthday.$setTouched();
                }
            } else {
                vm.dataForm.birthday.$setTouched();
            }

            if (vm.dataForm.street) {
                vm.dataForm.street.$setTouched();
                vm.dataForm.zip.$setTouched();
                vm.dataForm.city.$setTouched();
            }
            if (vm.dataForm.phone) {
                vm.dataForm.phone.$setTouched();
            }
            if (vm.dataForm.mobile_nr) {
                vm.dataForm.mobile_nr.$setTouched();
            }
            if(vm.dataForm.password) {
                vm.dataForm.password.$setTouched();
            }

            vm.dataForm.privacyterms.$setTouched();

            vm.miscError = false;

            if (vm.dataForm.$valid && (vm.registrationRequiredFields.IbanPflicht===false ||
                    (((vm.nichtKostenlos && vm.memberIban===true) || (_.isUndefined(vm.nichtKostenlos) || !vm.nichtKostenlos)) && vm.registrationRequiredFields.IbanPflicht===true ))) {
                if (vm.registrationRequiredFields.MobilPflicht === true) {
                    registration.mobile_nr = validator.whitelist(registration.mobile_nr, "+1234567890");
                }
                if (!checkDataRunning) {
                    checkDataRunning = true;
                    vm.dataLoading = true;
                    vm.lockedEmail = false;
                    var registrationData = {
                        email: registration.email,
                        firstname: registration.firstname,
                        lastname: registration.lastname,
                        birthday: registration.birthday
                    };
                    BookingService.checkRegistration(registrationData).then(function (data) {
                        if (data.IsLocked) {
                            vm.dataLoading = false;
                            vm.lockedEmail = true;
                            checkDataRunning = false;
                        } else if (data.uid) {
                            vm.alreadyRegistered = true;
                            vm.isDuplicate = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Loggen_sie_sich_ein";
                            checkDataRunning = false;
                            vm.dataLoading = false;
                        } else if (!data.uid) {
                            registration.PersonNr = data.uid;
                            vm.isDuplicate = false;
                            BookingService.createTemporaryMember(registration).then(function () {
                                checkDataRunning = false;
                                vm.dataLoading = false;
                                vm.registerFinish = true;
                                vm.errorText = "LT_Es_wurde_email_geschickt";
                            }).catch(function () {
                                checkDataRunning = false;
                                vm.dataLoading = false;
                                vm.errorHeader = "T_Fehler";
                                vm.errorText = "LT_Bei_senden_der_Verifizierungsemail_ist_ein_Fehler_aufgetreten";
                            });
                        } else {
                            vm.isDuplicate = true;
                            vm.alreadyRegistered = false;
                            vm.dataLoading = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio"
                        }
                    }).catch(function (error) {
                        if (error.status === 409) {
                            checkDataRunning = false;
                            vm.dataLoading = false;
                            vm.isDuplicate = true;
                            vm.alreadyRegistered = false;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Bitte_kontaktieren_Sie_Ihr_Studio"
                        } else {
                            vm.miscError = true;
                            vm.errorHeader = "T_Fehler";
                            vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten_beim_Registrieren";
                        }
                    })
                }
            }
            // return vm.dataForm.$valid;
        };


        let isRunning = false;
        let login = true;
        vm.finishRegister = function (registerData) {
            registerData.gender = registerData.salutation;

            if (!isRunning && vm.dataForm.code.$valid) {
                isRunning = true;
                vm.dataLoading = true;
                vm.dataForm.code.$setTouched();
                BookingService.checkRegisterCode(registerData).then(function (temporaryMember) {
                    if (temporaryMember.RightCode) {
                        vm.codeFalse = false;
                        if (vm.registrationRequiredFields.MobilPflicht === true) {
                            registerData.mobile_nr = validator.whitelist(registerData.mobile_nr, "+1234567890");
                        }
                        //registerData.salutation = null;
                        registerData.source = 5;
                        vm.registerFinish = false;
                        if(vm.booking.password) {
                            BookingService.createMember(registerData).then(function () {
                                vm.showSuccess = true;
                                isRunning = false;
                                vm.dataLoading = false;
                                AuthenticationService.login(vm.booking.email, vm.booking.password).then(function (response) {
                                    if (response != null) {
                                        $uibModalInstance.close({
                                            user: response
                                        });
                                        login = false;
                                        vm.dataLoading = false;
                                    } else {
                                        vm.wrongLoginData = true;
                                        vm.errorHeader = "T_Fehler";
                                        vm.errorText = "LT_Falsche_Logindaten";
                                        login = false;
                                        vm.dataLoading = false;
                                    }
                                }).catch(function (err) {
                                    vm.errorHeader = "T_Fehler";
                                    vm.errorText = "LT_Beim_der_Prüfung_der_Email_und_Kennwort_ist_ein_Fehler_aufgetreten";
                                    login = false;
                                    vm.dataLoading = false;
                                });
                            }).catch(function () {
                                //ToDo unterschieden ob beim create oder login...?
                                isRunning = false;
                                vm.dataLoading = false;
                                vm.codeFalse = false;
                                vm.errorHeader = "T_Fehler";
                                vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten_beim_Registrieren";
                            })
                        } else {
                                BookingService.createMemberAlsGast(registerData).then(function (data) {
                                    $localStorage.user = {};
                                    $localStorage.user.username = vm.booking.firstname + " " + vm.booking.lastname;
                                    $localStorage.user.Firstname = vm.booking.firstname;
                                    $localStorage.user.Lastname = vm.booking.lastname;
                                    $localStorage.user.isMember = false;
                                    $localStorage.user.memberNr = data.MemberNr;
                                    $localStorage.user.Email = vm.booking.email;
                                    $localStorage.user.uid = data.uid;
                                    $localStorage.user.isPayPal = data.IsPaypal;
                                    $localStorage.user.isBonitaet = false;
                                    if (data != null) {
                                        $uibModalInstance.close({
                                            user: data
                                        });
                                        login = false;
                                        vm.dataLoading = false;
                                    } else {
                                        vm.wrongLoginData = true;
                                        vm.errorHeader = "T_Fehler";
                                        vm.errorText = "LT_Falsche_Logindaten";
                                        login = false;
                                        vm.dataLoading = false;
                                    }
                                }).catch(function (err) {
                                    isRunning = false;
                                    vm.dataLoading = false;
                                    vm.codeFalse = false;
                                    vm.errorHeader = "T_Fehler";
                                    vm.errorText = "LT_Es_ist_ein_Fehler_aufgetreten_beim_Registrieren";
                                })
                            }

                    } else {
                        vm.codeFalse = true;
                        vm.dataLoading = false;
                        vm.errorHeader = "T_Fehler";
                        vm.errorText = "LT_Falscher_Code";
                        isRunning = false;
                    }
                }).catch(function () {
                    isRunning = false;
                    vm.dataLoading = false;
                })
            }
        };

        vm.checkIban = function () {
            return BookingService.isIbanValid(vm.booking.iban).then(
                function (valid) {
                    if (_.isUndefined(valid.isValid)) {
                        if (!valid) {
                            vm.memberIban = false;
                            vm.isDEIban = false;
                        } else {
                            vm.memberIban = true;
                            vm.isDEIban = true;
                        }

                    } else {
                        if (valid.isValid && valid.isDE) {
                            vm.memberIban = true;
                            vm.isDEIban = true;

                        }

                        if (valid.isValid && !valid.isDE) {
                            vm.memberIban = true;
                            vm.isDEIban = false;
                        }
                        if (!valid.isValid) {
                            vm.memberIban = false;
                            vm.isDEIban = false;
                        }
                    }

                }
            )

        }
    }
]);